module.exports = __webpack_public_path__ + "static/media/c2.ea13ae0f.jpg";